$(document).on("ready", function () {
    window.$ = window.jQuery = require("jquery");
    // window.Fancybox = require("./fancybox");
    $(".menu_toggle").on("click", function () {
        $("body").toggleClass("nav_open");
    });
    $(".menu_overlay").on("click", function () {
        $("body").removeClass("nav_open");
    });

    var hasChildMenu = $('.mobile_menu .has-children')

    $($(hasChildMenu)).click(function(e) {
        $(this)
            .next("ul")
            .toggleClass("mobile-menu-open");
        $(hasChildMenu)
            .not(this)
            .next("ul")
            .removeClass("mobile-menu-open");
        $(hasChildMenu)
            .not(this)
            .removeClass("active");
        $(this).toggleClass("active");
    });

    // Mobile menu trigger ends

    window.slick = require("./slick.min");

    var $carousel = $(".news_updates_slider");
    var $caseStudy = $(".case-study");
    var $solutionsSlider = $(".solutions-slider");

    if ($carousel.length) {
        var settings = {
            arrows: true,
            dots: true,
            // infinite: false,
            speed: 300,
            slidesToShow: 3,
            // slidesToScroll: 3,
            centerMode: true,
            centerPadding: "0px",
            slide: ".slick-slideshow__slide",
            responsive: [
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: false,
                    },
                },
            ],
        };

        function setSlideVisibility() {
            //Find the visible slides i.e. where aria-hidden="false"
            var visibleSlides = $carousel.find(
                '.slick-slideshow__slide[aria-hidden="false"]'
            );
            //Make sure all the visible slides have an opacity of 1
            $(visibleSlides).each(function () {
                $(this).css("opacity", 1);
            });

            //Set the opacity of the first and last partial slides.
            $(visibleSlides).first().prev().css("opacity", 0);
        }

        $carousel.slick(settings);
        $carousel.slick("slickGoTo", 1);
        // setSlideVisibility();

        // $carousel.on("afterChange", function () {
        //     setSlideVisibility();
        // });
    }

    if ($caseStudy.length) {
        var settings = {
            arrows: true,
            // dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 3,
            // centerMode: false,
            centerPadding: "0px",
            slide: ".slick-slideshow__slide",
            responsive: [
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: false,
                    },
                },
            ],
        };

        function setSlideVisibility() {
            //Find the visible slides i.e. where aria-hidden="false"
            var visibleSlides = $caseStudy.find(
                '.slick-slideshow__slide[aria-hidden="false"]'
            );
            //Make sure all the visible slides have an opacity of 1
            $(visibleSlides).each(function () {
                $(this).css("opacity", 1);
            });

            //Set the opacity of the first and last partial slides.
            $(visibleSlides).first().prev().css("opacity", 0);
        }

        $caseStudy.slick(settings);
        $caseStudy.slick("slickGoTo", 1);
        // setSlideVisibility();

        // $caseStudy.on("afterChange", function () {
        //     setSlideVisibility();
        // });
    }

    if ($solutionsSlider.length) {
        var settings = {
            arrows: true,
            // dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 3,
            // centerMode: false,
            centerPadding: "0px",
            slide: ".slick-slideshow__slide",
            responsive: [
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: false,
                    },
                },
            ],
        };

        function setSlideVisibility() {
            //Find the visible slides i.e. where aria-hidden="false"
            var visibleSlides = $solutionsSlider.find(
                '.slick-slideshow__slide[aria-hidden="false"]'
            );
            //Make sure all the visible slides have an opacity of 1
            $(visibleSlides).each(function () {
                $(this).css("opacity", 1);
            });

            //Set the opacity of the first and last partial slides.
            $(visibleSlides).first().prev().css("opacity", 0);
        }

        $solutionsSlider.slick(settings);
        $solutionsSlider.slick("slickGoTo", 1);
        // setSlideVisibility();

        // $solutionsSlider.on("afterChange", function () {
        //     setSlideVisibility();
        // });
    }
}); //end doc .ready

$(document).on("click", 'a[href^="#"]', function (event) {
    event.preventDefault();
    console.log ('-----', $($.attr(this, "href")));
    console.log ('-----', window.location.href.split("/").pop());

    if (window.location.href.split("/").pop() === 'business'){
        $("html, body").animate({
            scrollTop: $($.attr(this, "href")).offset().top - ($(".main_header").height()),
        }, 500);
    }else {
        $("html, body").animate(
            {
                scrollTop: $($.attr(this, "href")).offset().top,
            },
            500
        );
    }
});
// Smooth scroll ends

var toggleBtn = $(".toggle-btn");

toggleBtn.click( function () {
    $(this).parent().toggleClass('active');
});

hideOnClickOutside(toggleBtn.parent());

function hideOnClickOutside(selector) {
    const outsideClickListener = (event) => {
        const $target = $(event.target);
        if (!$target.closest(selector).length && $(selector).is(':visible')) {
            $(selector).removeClass('active');
            // removeClickListener();
        }
    }

    const removeClickListener = () => {
        document.removeEventListener('click', outsideClickListener);
    }

    document.addEventListener('click', outsideClickListener);
}
